{
  "multiInvoice": [],
  "multiInvoiceTotalCount": 0,
  "multiInvoiceErrorsCount": 0,
  "multiInvoiceSortExpression": null,
  "multiInvoiceFilterExpression": null,    
  "multiInvoicePaging": {
    "page": 1,
    "offset": 50
  }    
}